import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class CustodianAlert extends Component {
  render() {
    return (
      <div className="cell panel small-12 medium-12 large-12 ann green">
        <div className="ann-top">
          <div className="ann-cat">
            <span>
              notice
            </span>
            {/* <span>
              bar
            </span> */}
          </div>
          <div className="ann-head">
            <h2>Your wallet addresses have changed</h2>
          </div>
        </div>
        <div className="ann-bod">
          <p>
            Vaultoro now uses a secure custodian for storing crypto, and wallets have now been moved over to Bitgo.
          </p>
          <p>
            New wallet addresses will be created for you. You can find these by clicking the  <b>deposit</b> buttons within your wallets page.
          </p>
          <p>
            All old addresses will continue to work until Dec 31 2022.
          </p>
        </div>
        {/* <div className="ann-act">
        </div> */}
      </div>
    );
  }
}

export default withRouter(CustodianAlert);
